var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unread-separator"},[_c('i',{staticClass:"material-icons"},[_vm._v("bookmark")]),_c('span',{staticClass:"text f-medium"},[_vm._v("여기까지 읽었습니다.")])])
}]

export { render, staticRenderFns }